import {HttpEndpoint, Tendermint34Client, Tendermint37Client, TendermintClient} from "@cosmjs/tendermint-rpc";

import {accountFromAny, AccountParser} from "./account";
import {QueryClient} from "./query";

export interface ClientOptions {
  readonly accountParser?: AccountParser;
}

export class BaseClient {
  protected readonly tmClient: TendermintClient | undefined;
  protected readonly queryClient: QueryClient | undefined;
  protected readonly accountParser: AccountParser;

  public constructor(tmClient: TendermintClient | undefined, options: ClientOptions) {
    if (tmClient) {
      this.tmClient = tmClient;
      this.queryClient = new QueryClient(tmClient);
    }
    const {accountParser = accountFromAny} = options;
    this.accountParser = accountParser;
  }

  protected forceGetTmClient(): TendermintClient {
    if (!this.tmClient) {
      throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
    }
    return this.tmClient;
  }

  protected forceGetQueryClient(): QueryClient {
    if (!this.queryClient) {
      throw new Error("Query client not available. You cannot use online functionality in offline mode.");
    }
    return this.queryClient;
  }

  protected static async createTmClient(endpoint: string | HttpEndpoint) {
    // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
    // Using 0.34 as the fallback.
    let tmClient: TendermintClient;
    const tm37Client = await Tendermint37Client.connect(endpoint);
    const version = (await tm37Client.status()).nodeInfo.version;
    if (version.startsWith("0.37.")) {
      tmClient = tm37Client;
    } else {
      tm37Client.disconnect();
      tmClient = await Tendermint34Client.connect(endpoint);
    }
    return tmClient;
  }
}
